import * as d3 from 'd3';

/**
 * Counter-scale for unread dots inside a zoomed SVG canvas.
 * Keeps roughly constant screen size when zoomed out (no extra enlargement).
 */
export function computeUnreadDotZoomScale(zoomK) {
  return 1 / Math.max(zoomK || 1, 0.05);
}

/**
 * Append a pulsing blue unread dot to a D3 node group (Impact Path cards).
 * Uses the same blue as the own-node card frame (#5B9DD9).
 */
export function appendAiUnreadDot(nodeGroup, { x, y, radius = 5, scale = 1 }) {
  const group = nodeGroup.append('g')
    .attr('class', 'ai-unread-dot')
    .attr('data-x', x)
    .attr('data-y', y)
    .attr('transform', `translate(${x}, ${y}) scale(${scale})`)
    .style('pointer-events', 'none');

  const halo = group.append('circle')
    .attr('r', radius)
    .attr('fill', 'rgba(91, 157, 217, 0.55)')
    .attr('opacity', 0.78);

  halo.append('animate')
    .attr('attributeName', 'r')
    .attr('from', String(radius))
    .attr('to', String(radius * 2.4))
    .attr('dur', '2.4s')
    .attr('repeatCount', 'indefinite')
    .attr('calcMode', 'spline')
    .attr('keySplines', '0.22 1 0.36 1')
    .attr('keyTimes', '0;1');

  halo.append('animate')
    .attr('attributeName', 'opacity')
    .attr('from', '0.78')
    .attr('to', '0.12')
    .attr('dur', '2.4s')
    .attr('repeatCount', 'indefinite')
    .attr('calcMode', 'spline')
    .attr('keySplines', '0.22 1 0.36 1')
    .attr('keyTimes', '0;1');

  const core = group.append('circle')
    .attr('r', radius)
    .attr('fill', '#5B9DD9')
    .attr('opacity', 1);

  core.append('animate')
    .attr('attributeName', 'r')
    .attr('values', `${radius};${radius * 1.1};${radius}`)
    .attr('dur', '2.4s')
    .attr('repeatCount', 'indefinite')
    .attr('calcMode', 'spline')
    .attr('keySplines', '0.45 0 0.55 1;0.45 0 0.55 1')
    .attr('keyTimes', '0;0.5;1');

  core.append('animate')
    .attr('attributeName', 'opacity')
    .attr('values', '1;0.88;1')
    .attr('dur', '2.4s')
    .attr('repeatCount', 'indefinite')
    .attr('calcMode', 'spline')
    .attr('keySplines', '0.45 0 0.55 1;0.45 0 0.55 1')
    .attr('keyTimes', '0;0.5;1');

  return group;
}

export function updateAiUnreadDotZoom(layerRoot, zoomK) {
  if (!layerRoot) return;
  const scale = computeUnreadDotZoomScale(zoomK);
  layerRoot.selectAll('g.ai-unread-dot')
    .attr('transform', function transformDot() {
      const x = d3.select(this).attr('data-x');
      const y = d3.select(this).attr('data-y');
      return `translate(${x}, ${y}) scale(${scale})`;
    });
}
